import React from 'react';
import styled from 'styled-components';
import { useNavigate } from 'react-router-dom';

const HeroWrapper = styled.section`
  padding: 100px 20px;
  background-color: ${({ theme }) => theme.colors.primary};
  color: ${({ theme }) => theme.colors.white};
  text-align: center;
`;

const HeroTitle = styled.h1`
  font-size: 3rem;
  color: ${({ theme }) => theme.colors.white};
  font-weight: 700;
`;

const HeroSubtitle = styled.p`
  font-size: 1.25rem;
  margin-top: 10px;
`;

const HeroButton = styled.button`
  margin-top: 20px;
  padding: 15px 30px;
  font-size: ${({ theme }) => theme.fontSizes.medium};
  color: #fff;
  background-color: ${({ theme }) => theme.colors.primary};
  border-radius: 50px;
  cursor: pointer;
  transition: background-color 0.3s ease;

  &:hover {
    background-color: ${({ theme }) => theme.colors.accent};
  }
`;

const Hero = () => {
  const navigate = useNavigate();

  const handleGetStartedClick = () => {
    navigate('/services');
  };

  return (
    <HeroWrapper>
      <HeroTitle>Empowering Your Cloud Journey</HeroTitle>
      <HeroSubtitle>Innovative solutions for AWS, Azure, and Google Cloud.</HeroSubtitle>
      <HeroButton onClick={handleGetStartedClick}>Get Started</HeroButton>
    </HeroWrapper>
  );
};

export default Hero;
